// xhrRequest.js
// Send an HTTP request via XMLHttpRequest.
//
// Why XHR instead of fetch?
// The Emergent platform logger (assets.emergent.sh/scripts/emergent-main.js)
// monkey-patches window.fetch and calls response.text() on any non-2xx
// response WITHOUT cloning first. That leaves the Response body stream
// locked, so our app's subsequent response.json()/response.text() call
// throws "body stream already read". XHR uses a plain string buffer
// (xhr.responseText) — no stream, no lock — so it sidesteps the bug.
//
// Returns: { ok, status, data }
//   - data is the parsed JSON response, or { detail: <truncated raw> }
//     if the body wasn't valid JSON.
export function xhrRequest(method, url, { headers = {}, body = null, timeout = 30000 } = {}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    Object.entries(headers).forEach(([k, v]) => xhr.setRequestHeader(k, v));
    xhr.timeout = timeout;
    xhr.onload = () => {
      let data;
      try {
        data = xhr.responseText ? JSON.parse(xhr.responseText) : {};
      } catch {
        data = { detail: (xhr.responseText || '').slice(0, 200) };
      }
      resolve({
        ok: xhr.status >= 200 && xhr.status < 300,
        status: xhr.status,
        data,
      });
    };
    xhr.onerror = () => reject(new Error('Network error'));
    xhr.ontimeout = () => reject(new Error('Request timed out'));
    xhr.send(body);
  });
}
